import React, {useEffect, useRef, useState} from 'react';

//import * as LogFunctions from './../Helpers/LogFunctions';
import {
    ActivityIndicator,
    CCText, Modal,
    TouchableWithoutFeedback,
    View
} from '../../../custom-packages/react-native-components-in-react/react-native-components-in-react';

import {useSelector} from 'react-redux';

import DefaultButton, {
    BorderlessButton,
    DarkButton, TagButton,
    ThemeButton
} from '../../../custom-packages/react-button-package/ButtonPackage';

import ChocoForm, {FormModal} from "../../../custom-packages/react-chocoforms/legacy/ChocoForm";
import AppConfig from '../../../AppConfig';

import {useNavigate, useParams} from "react-router-dom";
import {LightenColor} from "../../../ColorFunctions";
import MenuPreview from "../../../components/admin/Menu/MenuPreview";
import UpgradeModal from "../../../components/admin/Subscription/UpgradeModal";
import Styles from "../../../Styles";
import QRCodeModal from "../../../custom-packages/QRCodeWrapper/QRCodeModal";
import ContextualActionBar from "../../../custom-packages/contextual-action-bar/ContextualActionBar";
import {TMenuCustomizerScreen} from "../../admin/Menu/Editor/MenuCustomizerScreen";
import {SetMenuData} from "../../../LocalStorageFunctions";
import {RegisterEvent} from "../../../AnalyticsFunctions";

const TDemoScreen = {
    "enUS": {
        DEMO: 'Change and save your appearance',
        CALL_TO_ACTION: 'Create Account',
        CALL_TO_ACTION_DESC: 'All your changes will be saved',
    },
    "esMX": {
        DEMO: 'Cambia y guarda su apariencia',
        CALL_TO_ACTION: 'Crear Cuenta',
        CALL_TO_ACTION_DESC: 'Todos tus cambios serán guardados',
    }
}

const DemoScreen = (props) => {
    const auth = useSelector(state => state.Auth);

    const params = useParams()
    const navigate = useNavigate()

    const [needsPreview, setNeedsPreview] = useState(false);
    const [menu, setMenu] = useState({
        meN_NAME: 'La Casa Del Tiburón'
    });
    const [styleForm, setStyleForm] = useState({
        controls: {
            MEN_PRIMARY_COLOR: {
                elementType: 'color',
                elementConfig: {
                    placeholder: TMenuCustomizerScreen[AppConfig.lang].PRIMARY_COLOR,
                },
                label: TMenuCustomizerScreen[AppConfig.lang].PRIMARY_COLOR + '*',
                value: '#000000',
                className: 'col-6',
                errorMessage: '',
                validation: {
                    required: true
                },
            },
            MEN_BACKGROUND_COLOR: {
                elementType: 'color',
                elementConfig: {
                    placeholder: TMenuCustomizerScreen[AppConfig.lang].BACKGROUND_COLOR,
                },
                label: TMenuCustomizerScreen[AppConfig.lang].BACKGROUND_COLOR + '*',
                value: '#ffffff',
                className: 'col-6',
                errorMessage: '',
                validation: {
                    required: true
                },
            },
            MEN_FONT_FAMILY: {
                elementType: 'select',
                elementConfig: {
                    placeholder: TMenuCustomizerScreen[AppConfig.lang].FONT_FAMILY,
                },
                label: TMenuCustomizerScreen[AppConfig.lang].FONT_FAMILY + '*',
                value: 'Roboto',
                className: 'col-6',
                valuesAreFonts: true,
                options: [{
                    value: 'Aclonica',
                    label: 'Aclonica'
                }, {
                    value: 'ADLaMDisplay',
                    label: 'ADLaMDisplay'
                }, {
                    value: 'Arial',
                    label: 'Arial'
                }, {
                    value: 'ConcertOne',
                    label: 'ConcertOne'
                }, {
                    value: 'Courier New',
                    label: 'Courier New'
                }, {
                    value: 'Electrolize',
                    label: 'Electrolize'
                }, {
                    value: 'Georgia',
                    label: 'Georgia'
                }, {
                    value: 'Helvetica',
                    label: 'Helvetica'
                }, {
                    value: 'Lobster',
                    label: 'Lobster'
                }, {
                    value: 'Palatino',
                    label: 'Palatino'
                }, {
                    value: 'PermanentMarker',
                    label: 'Permanent Marker'
                }, {
                    value: 'PressStart2P',
                    label: 'Press Start 2P'
                }, {
                    value: 'Righteous',
                    label: 'Righteous'
                }, {
                    value: 'Roboto',
                    label: 'Roboto'
                }, {
                    value: 'SpecialElite',
                    label: 'Special Elite'
                }, {
                    value: 'Tahoma',
                    label: 'Tahoma'
                }, {
                    value: 'Times',
                    label: 'Times'
                }, {
                    value: 'Times New Roman',
                    label: 'Times New Roman'
                }, {
                    value: 'Verdana',
                    label: 'Verdana'
                },],
                errorMessage: '',
                validation: {
                    required: true
                },
            },
            MEN_TEXT_ALIGN: {
                elementType: 'select',
                elementConfig: {
                    placeholder: TMenuCustomizerScreen[AppConfig.lang].TEXT_ALIGN,
                },
                label: TMenuCustomizerScreen[AppConfig.lang].TEXT_ALIGN + '*',
                value: 'left',
                className: 'col-6',
                options: [{
                    value: 'left',
                    label: TMenuCustomizerScreen[AppConfig.lang].LEFT
                }, {
                    value: 'center',
                    label: TMenuCustomizerScreen[AppConfig.lang].CENTER
                }, {
                    value: 'right',
                    label: TMenuCustomizerScreen[AppConfig.lang].RIGHT
                }],
                errorMessage: '',
                validation: {
                    required: true
                },
            },
        },
    });
    const [cardForm, setCardForm] = useState({
        controls: {
            MEN_CARD_BACKGROUND_COLOR: {
                elementType: 'color',
                elementConfig: {
                    placeholder: TMenuCustomizerScreen[AppConfig.lang].BACKGROUND_COLOR,
                },
                label: TMenuCustomizerScreen[AppConfig.lang].BACKGROUND_COLOR + '*',
                value: '#000000',
                className: 'col-6',
                errorMessage: '',
                validation: {
                    required: true
                },
            },
            MEN_CARD_BORDER_COLOR: {
                elementType: 'color',
                elementConfig: {
                    placeholder: TMenuCustomizerScreen[AppConfig.lang].BORDER_COLOR,
                },
                label: TMenuCustomizerScreen[AppConfig.lang].BORDER_COLOR + '*',
                value: '#d1d1d1',
                className: 'col-6',
                errorMessage: '',
                validation: {
                    required: true
                },
            },
            MEN_CARD_BORDER_WIDTH: {
                elementType: 'slider',
                elementConfig: {
                    placeholder: TMenuCustomizerScreen[AppConfig.lang].BORDER_WIDTH,
                },
                label: TMenuCustomizerScreen[AppConfig.lang].BORDER_WIDTH + '*',
                value: 1,
                step: 1,
                errorMessage: '',
                validation: {
                    required: true,
                    min: 0,
                    max: 10
                },
            },
            MEN_CARD_BORDER_RADIUS: {
                elementType: 'slider',
                elementConfig: {
                    placeholder: TMenuCustomizerScreen[AppConfig.lang].BORDER_RADIUS,
                },
                label: TMenuCustomizerScreen[AppConfig.lang].BORDER_RADIUS + '*',
                value: 10,
                step: 5,
                errorMessage: '',
                validation: {
                    required: true,
                    min: 0,
                    max: 40
                },
            },
            MEN_CARD_OPACITY: {
                elementType: 'slider',
                elementConfig: {
                    placeholder: TMenuCustomizerScreen[AppConfig.lang].OPACITY,
                },
                label: TMenuCustomizerScreen[AppConfig.lang].OPACITY + '*',
                value: 1,
                step: .1,
                errorMessage: '',
                validation: {
                    required: true,
                    min: 0,
                    max: 1
                },
            },
            MEN_CARD_SHADOW_INTENSITY: {
                elementType: 'slider',
                elementConfig: {
                    placeholder: TMenuCustomizerScreen[AppConfig.lang].SHADOW_INTENSITY,
                },
                label: TMenuCustomizerScreen[AppConfig.lang].SHADOW_INTENSITY + '*',
                value: 1,
                step: 1,
                errorMessage: '',
                validation: {
                    required: true,
                    min: 0,
                    max: 5
                },
            },
        },
    });

    return <View
        style={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'white',
            alignItems: 'stretch',
            flexDirection: 'row'
        }}
    >
        <View
            className={'row'}
            style={{
                margin: 0,
                alignItems: 'stretch',
                width: '100%'
            }}
        >
            <View className={'col-lg-1'}></View>
            <View
                className={'col-lg-4'}
                style={{
                    paddingTop: 50,
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <h1 style={{
                    textAlign: 'center',
                    marginBottom: 30
                }}>
                    {TDemoScreen[AppConfig.lang].DEMO}
                </h1>
                <ChocoForm
                    containerStyle={{padding: 0}}
                    lang={AppConfig.lang}
                    form={styleForm}
                    onFormChange={(updatedForm) => {
                        if (updatedForm.controls.MEN_PRIMARY_COLOR.value !== styleForm.controls.MEN_PRIMARY_COLOR.value) {
                            updatedForm.controls.MEN_BACKGROUND_COLOR.value = LightenColor(updatedForm.controls.MEN_PRIMARY_COLOR.value, 0.8);
                        }

                        if (!needsPreview)
                            setNeedsPreview(true)

                        updatedForm.edited = true

                        setStyleForm(updatedForm)
                    }}
                />
                <View>
                    <h5 style={{marginTop: 15}}>
                        {TMenuCustomizerScreen[AppConfig.lang].CARD_STYLES}
                    </h5>
                    <ChocoForm
                        containerStyle={{padding: 0}}
                        lang={AppConfig.lang}
                        form={cardForm}
                        onFormChange={(updatedForm) => {
                            if (updatedForm.controls.MEN_CARD_BACKGROUND_COLOR.value !== cardForm.controls.MEN_CARD_BACKGROUND_COLOR.value) {
                                updatedForm.controls.MEN_CARD_OPACITY.value = 1;
                            }

                            if (updatedForm.controls.MEN_CARD_OPACITY.value == 0) {
                                updatedForm.controls.MEN_CARD_SHADOW_INTENSITY.value = 0;
                            }

                            if (!needsPreview)
                                setNeedsPreview(true)

                            updatedForm.edited = true

                            setCardForm(updatedForm)
                        }}
                    />
                </View>
                <View
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'flex-end',
                        width: '100%'
                    }}
                >
                    <ThemeButton
                        style={{
                            width: 'fit-content',
                            borderRadius: 30,
                            padding: '10px 15px',
                            fontWeight: 'bold',
                        }}
                        text={TDemoScreen[AppConfig.lang].CALL_TO_ACTION}
                        onPress={() => {
                            try {
                                RegisterEvent({
                                    source: window.location.href,
                                    sequenceID: AppConfig.ANALYTICS_SEQUENCE_SIGNUP,
                                    action: 'DEMO_CALL_TO_ACTION'
                                })
                            } catch (e) {

                            }

                            const styleControls = {...styleForm.controls};
                            const cardControls = {...cardForm.controls};

                            let formData = {};

                            for (let key in styleControls) {
                                formData[key] = styleControls[key].value;
                            }

                            for (let key in cardControls) {
                                formData[key] = cardControls[key].value;
                            }

                            const data = JSON.stringify(formData);

                            SetMenuData(data);

                            navigate('/register/business')
                        }}
                    />
                </View>
                <View
                    style={{
                        marginTop: 10,
                        marginBottom: 30,
                        textAlign: 'right',
                        width: '100%',
                        fontWeight: 'bold'
                    }}
                >
                    {TDemoScreen[AppConfig.lang].CALL_TO_ACTION_DESC}
                </View>
            </View>
            <View className={'col-lg-1'}></View>
            <View
                className={'col-lg-6'}
                style={{
                    backgroundColor: Styles.basicBackgroundColor.color,
                    paddingTop: 30,
                    paddingBottom: 30,
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <View
                    style={{
                        maxWidth: 350,
                        alignSelf: 'center',
                        borderRadius: 20,
                        border: '3px solid white',
                        overflow: 'hidden',
                        boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.2)'
                    }}
                >
                    <PreviewWrapper
                        version={'DESKTOP'}
                        menu={menu}
                        styleForm={styleForm}
                        cardForm={cardForm}
                    />
                </View>
            </View>
        </View>
    </View>;
}

export default DemoScreen;

const PreviewWrapper = ({menu, styleForm, cardForm}) => {

    return <MenuPreview
        config={{
            logo: menu.meN_LOGO,
            name: menu.meN_NAME,
            primaryColor: styleForm.controls.MEN_PRIMARY_COLOR.value,
            backgroundColor: styleForm.controls.MEN_BACKGROUND_COLOR.value,
            fontFamily: styleForm.controls.MEN_FONT_FAMILY.value,
            textAlign: styleForm.controls.MEN_TEXT_ALIGN.value,
            cardBackgroundColor: cardForm.controls.MEN_CARD_BACKGROUND_COLOR.value,
            cardBorderWidth: cardForm.controls.MEN_CARD_BORDER_WIDTH.value,
            cardBorderColor: cardForm.controls.MEN_CARD_BORDER_COLOR.value,
            cardBorderRadius: cardForm.controls.MEN_CARD_BORDER_RADIUS.value,
            cardOpacity: cardForm.controls.MEN_CARD_OPACITY.value,
            cardShadowIntensity: cardForm.controls.MEN_CARD_SHADOW_INTENSITY.value,
        }}
        currentSection={{
            id: 's-1',
            name: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_SECTION + ' ' + 1
        }}
        menuSections={[
            {
                id: 's-1',
                name: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_SECTION + ' ' + 1
            },
            {
                id: 's-2',
                name: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_SECTION + ' ' + 2
            },
        ]}
        food={[
            {
                title: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_SECTION + ' ' + 1,
                id: 'f-1',
                name: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_FOOD + ' ' + 1,
                prices: [
                    {
                        name: 'DEFAULT',
                        price: 99,
                        currency: 'MXN'
                    }
                ]
            },
            {
                id: 'f-2',
                name: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_FOOD + ' ' + 2,
                prices: [
                    {
                        name: 'DEFAULT',
                        price: 50,
                        currency: 'MXN'
                    }
                ],
                description: TMenuCustomizerScreen[AppConfig.lang].PREVIEW_DESCRIPTION
            },
        ]}
    />
}